import { render } from "./Footer.vue?vue&type=template&id=1b68a7d8&scoped=true&ts=true"
import script from "./Footer.vue?vue&type=script&lang=ts"
export * from "./Footer.vue?vue&type=script&lang=ts"

import "@/components/Footer/style.scss?vue&type=style&index=0&id=1b68a7d8&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b68a7d8"]])

export default __exports__